module.exports = __webpack_public_path__ + "static/media/mobile11.e31c61ae.png";